import React, { createRef, useEffect, useRef, useState } from "react";
import styles from './Home.module.css';
import { useOutletContext } from "react-router-dom";
import Spinners from "./Spinners";
import HoverTextPara from "./HoverTextPara";
import ImageSwitcher from "./ImageSwitcher";
import { ReactComponent as Logo } from '../../imgs/designStrat/stratNew.svg';
import SLogo from "../footer/SLogo";
import SLogoNew from "../footer/SLogoNew";
import SLogoLoading from "../footer/SLogoLoading";
import { buildImgArray, aboutUsImgArray, visionImgArray, designStrategyImgArray, designStrategyImgArrayMobile } from "./ImageConfig";

export default function Home(){

    useEffect(() => {
        // window.scrollTo(0,0);
    },[]);

    const stickCon1Ref = useRef();
    const stickCon2Ref = useRef();
    const stickCon3Ref = useRef();
    const stickBlock1Ref = useRef();
    const stickBlock2Ref = useRef();
    const stickBlock3Ref = useRef();

    const movingLogoCon = useRef();
    const movingLogoBlock = useRef();

    const [displayMovingLogo,setDisplayMovingLogo] = useState(true);

    const firstImageCon = useRef();
    const firstImage = useRef();

    const tiltingBlockOuterRef = useRef();
    const tiltingBlockRef = useRef();
    const glowBlockRef = useRef();

    const expandingGridRef = useRef();

    const servicesCarouselRef = useRef();
    const servicesCarouselInteriorConRef = useRef();
    const servicesCarouselInteriorRef = useRef();

    const serviceBlockData = [
        {
            name: 'Brand Identity',
            img: './imgs/initialImages/guyWork1-PS-LR.jpg'
        },
        {
            name: 'Brand Management & Implementation',
            img: './imgs/initialImages/sarahDesk1-PS-LR.jpg'
        },
        {
            name: 'Signage & Environmental Graphics',
            img: './imgs/initialImages/IMG_1627-PS-LS.jpg'
        },
        {
            name: 'Project Management',
            img: './imgs/initialImages/TreeHouse2-PS-LR.jpg'
        },
        {
            name: 'Exhibition Design',
            img: './imgs/initialImages/houseFront1-PS-LR.jpg'
        },
        {
            name: 'Animation Design',
            img: './imgs/office_and_externals/deer3comp.jpg'
        },
        {
            name: 'Interior & Architectural Design',
            img: './imgs/office_and_externals/treeLeftRoot1comp.JPG'
        },
        {
            name: 'Industrial Product Design',
            img: './imgs/initialImages/houseLeaves1-PS-LR.jpg'
        }
    ];
    
    // Images are now configured in ImageConfig.js
    // Adjust positioning, zoom, and all image settings from that file

    const [serviceCurrentSlide,setServiceCurrentSlide] = useState(null);
    const [serviceActiveSlide,setServiceActiveSlide] = useState(null);
    const [serviceProgress,setServiceProgress] = useState(0);

    useEffect(() => {
        setServiceActiveSlide(null);
    },[serviceCurrentSlide])

    const serviceBlocks = useRef(serviceBlockData.map(() => createRef()));

    const [stickyBlockState1,setStickyBlockState1] = useState(0);
    const [stickyBlockState2,setStickyBlockState2] = useState(0);
    const [stickyBlockState3,setStickyBlockState3] = useState(0);

    const [logoStatePt1,setLogoStatePt1] = useState(0);
    const [logoStatePt2,setLogoStatePt2] = useState(0);

    const {mobileVersion} = useOutletContext();

    const [headingStyles,setHeadingStyles] = useState({
        top: (window.innerHeight/2) - (7.875*16),
        opacity: 1
    });
    const [aboutUsSectionImgStyles,setAboutUsSectionImgStyles] = useState({
        top: 0
    });
    const [aboutUsSectionTextStyles,setAboutUsSectionTextStyles] = useState({
        top: 0,
        opacity: 1
    });
    const [visionSectionImgStyles,setVisionSectionImgStyles] = useState({
        top: 0
    });
    const [visionSectionTextStyles,setVisionSectionTextStyles] = useState({
        top: 0,
        opacity: 1
    });
    const [buildManageSectionImgStyles,setBuildManageSectionImgStyles] = useState({
        top: 0
    });
    const [buildManageSectionTextStyles,setBuildManageSectionTextStyles] = useState({
        top: 0,
        opacity: 1
    });
    const [ourServicesSectionTextStyles,setOurServicesSectionTextStyles] = useState({
        top: 0,
        opacity: 1
    });
    const [designStrategySectionTextStyles,setDesignStrategySectionTextStyles] = useState({
        top: 0,
        opacity: 1
    });
    const [designStrategySectionImgStyles,setDesignStrategySectionImgStyles] = useState({
        top: 0
    });
    const [ourServicesOverlayOpacity,setOurServicesOverlayOpacity] = useState({
        opacity: 1
    });
    const [openService,setOpenService] = useState('');

    // Track section visibility for slideshow reset
    const [buildManageSectionInView,setBuildManageSectionInView] = useState(false);
    const [aboutUsSectionInView,setAboutUsSectionInView] = useState(false);
    const [designStrategySectionInView,setDesignStrategySectionInView] = useState(false);
    const [visionSectionInView,setVisionSectionInView] = useState(false);

    const openServiceObj = {
        openService,
        setOpenService
    };

    useEffect(() => {
        servicesFunctionOnly('ourServicesSection',setOurServicesSectionTextStyles);
    },[openService]);

    const titleHeadingScrollFunction = () => {
        const headingDefaultTop = (window.innerHeight/2) - (7.875*16);
        const newHeadingTop = headingDefaultTop - (window.scrollY/1.5);
        let opacity = newHeadingTop/headingDefaultTop;
        if(newHeadingTop < 0){
            opacity = 0;
        };
        setHeadingStyles({
            top: newHeadingTop,
            opacity: opacity
        });
    }

    const imgScrollFunctionNew = (parentElementId,setterFunction,mobile) => {
        const elementExist = document.getElementById(parentElementId);
        if(elementExist){
            const element = document.getElementById(parentElementId).getBoundingClientRect();
        
            const viewportHeight = window.innerHeight;

            let topPosition;

            if(!mobile){
                if (element.top >= viewportHeight){
                    // start position
                    topPosition = 0;
                } else if (element.bottom <= 0) {
                    // end position
                    topPosition = -0.25*viewportHeight;
                } else {
                    topPosition = viewportHeight*((element.top/viewportHeight)-1)/8;
                }
            } else {
                if (element.top >= viewportHeight){
                    // start position
                    topPosition = 0;
                } else if (element.bottom <= 0) {
                    // end position
                    topPosition = -0.125*viewportHeight;
                } else {
                    topPosition = viewportHeight*((element.top/viewportHeight)-1)/16;
                }
            }
            setterFunction({
                top: topPosition
            });
        }
    }

    const textScrollFunctionNew = (parentElementId,setterFunction) => {
        const elementExist = document.getElementById(parentElementId);
        if(elementExist){
            const element = document.getElementById(parentElementId).getBoundingClientRect();
        
            const viewportHeight = window.innerHeight;
    
            let topPosition;
            if (element.top >= viewportHeight){
                // start position
                topPosition = 0;
            } else if (element.bottom <= 0) {
                // end position
                topPosition = -0.5*viewportHeight;
            } else {
                topPosition = viewportHeight*((element.top/viewportHeight)-1)/4;
            }
    
            let opacity;
            if(element.top >= viewportHeight){
                opacity = 0;
            } else if (element.bottom <= 0) {
                opacity = 0;
            } else if (element.top <= viewportHeight*0.25 && element.top >= viewportHeight*(-0.25)){
                opacity = 1;
            } else if (element.top > viewportHeight*0.25 && element.top < viewportHeight){
                opacity = (4/3)*(1-(element.top/viewportHeight));
            } else if (element.top < viewportHeight*(-0.25) && element.bottom > 0){
                opacity = (4/3)*(1+(element.top/viewportHeight));
            }
            // console.log(`opacity: `+opacity);
            setterFunction({
                top: topPosition,
                opacity
            });
        }
    }

    const servicesFunctionOnly = (parentElementId,setterFunction) => {
        const element = document.getElementById(parentElementId).getBoundingClientRect();
    
        const viewportHeight = window.innerHeight;

        let topPosition;
        if (element.top >= viewportHeight){
            // start position
            topPosition = 0;
        } else if (element.bottom <= 0) {
            // end position
            topPosition = -0.5*viewportHeight;
        } else {
            topPosition = viewportHeight*((element.top/viewportHeight)-1)/4;
        }

        let opacity;
        if(element.top >= viewportHeight){
            opacity = 0;
        } else if (element.bottom <= 0) {
            opacity = 0;
        } else if (element.top <= viewportHeight*0.5 && element.bottom >= viewportHeight*(0.15)){
            opacity = 1;
        } else if (element.top > viewportHeight*0.5 && element.top < viewportHeight){
            opacity = 0;
        } else if (element.top < viewportHeight*(-0.25) && element.bottom > 0){
            opacity = (4/3)*(1+(element.top/viewportHeight));
        }
        // console.log(`opacity: `+opacity);
        setterFunction({
            top: topPosition,
            opacity
        });

    }

    useEffect(() => {
        if(ourServicesSectionTextStyles.opacity > 0.99){
            setOurServicesOverlayOpacity({opacity: 1});
        } else {
            setOurServicesOverlayOpacity({opacity: 0});
        }
    },[ourServicesSectionTextStyles.opacity]);

    const checkSectionInView = (sectionId) => {
        const element = document.getElementById(sectionId);
        if(!element) return false;
        const rect = element.getBoundingClientRect();
        const viewportHeight = window.innerHeight;
        // Section is in view if it's within the viewport (top is above bottom of viewport and bottom is below top of viewport)
        return rect.top < viewportHeight && rect.bottom > 0;
    };

    const onScrollFunction = () => {
        titleHeadingScrollFunction();
        textScrollFunctionNew('aboutUsSection',setAboutUsSectionTextStyles);
        imgScrollFunctionNew('aboutUsSection',setAboutUsSectionImgStyles,mobileVersion);
        textScrollFunctionNew('designStrategySection',setDesignStrategySectionTextStyles);
        imgScrollFunctionNew('designStrategySection',setDesignStrategySectionImgStyles,mobileVersion);
        textScrollFunctionNew('visionSection',setVisionSectionTextStyles);
        imgScrollFunctionNew('visionSection',setVisionSectionImgStyles,mobileVersion);
        textScrollFunctionNew('buildManageSection',setBuildManageSectionTextStyles);
        imgScrollFunctionNew('buildManageSection',setBuildManageSectionImgStyles,mobileVersion);
        servicesFunctionOnly('ourServicesSection',setOurServicesSectionTextStyles);
        // stickyConFunc(stickCon1Ref,stickBlock1Ref,setStickyBlockState1);
        // stickyConFunc(stickCon2Ref,stickBlock2Ref,setStickyBlockState2);
        // stickyConFunc(stickCon3Ref,stickBlock3Ref,setStickyBlockState3);
        movingLogoFunc();
        firstImageFunc();
        // servicesCarouselFunc();
        
        // Check section visibility for slideshow reset
        setBuildManageSectionInView(checkSectionInView('buildManageSection'));
        setAboutUsSectionInView(checkSectionInView('aboutUsSection'));
        setDesignStrategySectionInView(checkSectionInView('designStrategySection'));
        setVisionSectionInView(checkSectionInView('visionSection'));
    }

    const mouseMoveFunction = (e) => {
        // console.log(e)
        // tiltingFunction(e,tiltingBlockOuterRef,tiltingBlockRef);
        // hoverGlowFunction(e,glowBlockRef);
    }

    const tiltingFunction = (e,outerRef,blockRef) => {
        if(blockRef){
            const blockTop = outerRef.current.getBoundingClientRect().top;
            const blockBottom = outerRef.current.getBoundingClientRect().bottom;
            const blockLeft = outerRef.current.getBoundingClientRect().left;
            const blockRight = outerRef.current.getBoundingClientRect().right;
            const blockMiddleX = (blockRight+blockLeft)/2;
            const blockMiddleY = (blockTop+blockBottom)/2;
            const blockWidth = blockRight-blockLeft;
            const blockHeight = blockBottom-blockTop;
            const mousePosX = e.clientX;
            const mousePosY = e.clientY;
            const buffer = 0;
            let xTilt;
            let yTilt;
            if(e.clientX >= (blockLeft - buffer) && e.clientX <= (blockRight + buffer) && e.clientY >= (blockTop - buffer) && e.clientY <= (blockBottom + buffer)){
                xTilt = (mousePosX-blockMiddleX)/(blockWidth/2);
                yTilt = (mousePosY-blockMiddleY)/(blockHeight/2);
                // console.log('inside');
                // console.log('blockTop',blockTop,'blockBottom',blockBottom,'blockLeft',blockLeft,'blockRight',blockRight);
                blockRef.current.style.transform = `perspective(1000px) rotateX(${-yTilt*5}deg) rotateY(${xTilt*5}deg)`;
            } else {
                // console.log('outside');
                blockRef.current.style.transform = `perspective(1000px) rotateX(0deg) rotateY(0deg)`;
            }
        }
    }

    const hoverGlowFunction = (e,blockRef) => {
        if(blockRef){
            const blockTop = blockRef.current.getBoundingClientRect().top;
            const blockBottom = blockRef.current.getBoundingClientRect().bottom;
            const blockLeft = blockRef.current.getBoundingClientRect().left;
            const blockRight = blockRef.current.getBoundingClientRect().right;
            const mousePosX = e.clientX;
            const mousePosY = e.clientY;
            let xTilt;
            let yTilt;
            if(e.clientX >= blockLeft && e.clientX <= blockRight && e.clientY >= blockTop && e.clientY <= blockBottom){
                blockRef.current.style = `--x: ${mousePosX-blockLeft}px; --y: ${mousePosY-blockTop}px`;
            } else {
                blockRef.current.style.transform = `perspective(1000px) rotateX(0deg) rotateY(0deg)`;
            }
        }
    }

    const stickyConFunc = (conRef,blockRef,stateSetter) => {
        const viewportHeight = window.innerHeight;
        const blockTop = conRef.current.getBoundingClientRect().top;
        const blockBottom = conRef.current.getBoundingClientRect().bottom;
        if(blockTop <= 0){
            blockRef.current.style.position = `fixed`;
            blockRef.current.style.top = `${0}px`;
            if(blockBottom <= viewportHeight && blockBottom > 0){
                stateSetter((((viewportHeight)-blockBottom)/(viewportHeight)))
            }
        } else {
            blockRef.current.style.position = `absolute`;
            blockRef.current.style.top = `0px`;
        }
    }

    const movingLogoFunc = () => {
        const viewportHeight = window.innerHeight;
        const blockHeight = movingLogoCon.current.getBoundingClientRect().bottom - movingLogoCon.current.getBoundingClientRect().top;
        const halfHeight = blockHeight/2;
        const blockTop = movingLogoCon.current.getBoundingClientRect().top;
        const blockBottom = movingLogoCon.current.getBoundingClientRect().bottom;
        const blockMiddle = (movingLogoCon.current.getBoundingClientRect().bottom + movingLogoCon.current.getBoundingClientRect().top)/2;
        const twoThirdsHeight = 2*blockHeight/3;
        const blockTwoThirds = (movingLogoCon.current.getBoundingClientRect().bottom + movingLogoCon.current.getBoundingClientRect().top)/2;

        if (blockTop >= 0) {
            setLogoStatePt1(0);
            setLogoStatePt2(0);
            movingLogoBlock.current.style.position = `absolute`;
            movingLogoBlock.current.style.top = `0`;
            movingLogoBlock.current.style.bottom = `unset`;
            movingLogoBlock.current.style.display = `block`;
            setDisplayMovingLogo(true);
        } else if (blockTop <= 0 && blockMiddle >= viewportHeight/2){
            setLogoStatePt1((2*(1-((halfHeight+blockTop)/(halfHeight)))));
            setLogoStatePt2(0);
            movingLogoBlock.current.style.position = `fixed`;
            movingLogoBlock.current.style.top = `0`;
            movingLogoBlock.current.style.display = `block`;
            setDisplayMovingLogo(true);
        } else if (blockMiddle < viewportHeight && blockBottom >= viewportHeight) {
            setLogoStatePt1(1);
            setLogoStatePt2(2*(1.5-(((halfHeight)+blockMiddle)/(halfHeight))));
            movingLogoBlock.current.style.position = `fixed`;
            movingLogoBlock.current.style.top = `0`;
            movingLogoBlock.current.style.display = `block`;
            setDisplayMovingLogo(true);
        } else if (blockBottom < viewportHeight && blockBottom > 0){
            setLogoStatePt1(1);
            setLogoStatePt2(1);
            movingLogoBlock.current.style.position = `absolute`;
            movingLogoBlock.current.style.top = `unset`;
            movingLogoBlock.current.style.bottom = `0`;
            movingLogoBlock.current.style.display = `block`;
            setDisplayMovingLogo(true);
        } else if(blockBottom <= 0){
            // movingLogoBlock.current.style.top = `unset`;
            // movingLogoBlock.current.style.bottom = `0`;
            movingLogoBlock.current.style.display = `none`;
            setDisplayMovingLogo(false);
        }
    }

    const firstImageFunc = () => {
        const viewportHeight = window.innerHeight;
        const blockTop = firstImageCon.current.getBoundingClientRect().top;
        const blockBottom = firstImageCon.current.getBoundingClientRect().bottom;
        const firstImageTop = firstImage.current.getBoundingClientRect().top;
        const firstImageBottom = firstImage.current.getBoundingClientRect().bottom;

        if (blockTop > viewportHeight) {
            firstImage.current.style.opacity = `0`;
            firstImage.current.style.top = '-25lvh'
        } else if (blockTop <= viewportHeight && blockBottom >= 0){
            firstImage.current.style.opacity = `1`;
            firstImage.current.style.top = `-${25*(blockBottom/(1.75*viewportHeight))}vh`
        } else if (blockBottom < 0){
            firstImage.current.style.opacity = `0`;
            firstImage.current.style.top = '0'
        }
    }

    const servicesCarouselFunc = () => {
        const noOfBlocks = 8;
        const servCarBlock = servicesCarouselRef.current.getBoundingClientRect();
        const servCarBlockInteriorCon = servicesCarouselInteriorConRef.current.getBoundingClientRect();
        const topBottom = Number(window.innerHeight/2)+Number(servCarBlockInteriorCon.bottom - servCarBlockInteriorCon.top)-Number(servCarBlock.bottom - servCarBlock.top);
        if(servCarBlock.top <= 0 && servCarBlock.bottom >= window.innerHeight){
            servicesCarouselInteriorConRef.current.style.position = 'fixed';
            servicesCarouselInteriorConRef.current.style.top = `0`;
            servicesCarouselInteriorConRef.current.style.bottom = `unset`;
            // console.log(servCarBlock.top,window.innerHeight/2)
            if(servCarBlock.top < 0){
                const sectionNo = Math.floor(Math.abs(servCarBlock.top)/((servCarBlock.bottom-servCarBlock.top)/(1+noOfBlocks)));
                // console.log('section no.',sectionNo);
                servicesCarouselInteriorRef.current.style.transform = `translate(0,-${sectionNo*((window.innerHeight/2)+(4*16))}px)`;  
                setServiceCurrentSlide(sectionNo);
            }
            setServiceProgress(1-(Math.abs((servCarBlock.bottom-servCarBlock.top)+servCarBlock.top-window.innerHeight)/(servCarBlock.bottom-servCarBlock.top-window.innerHeight)));
       } else if (servCarBlock.top > 0 ){
            servicesCarouselInteriorConRef.current.style.position = 'absolute';
            servicesCarouselInteriorConRef.current.style.top = `100vh`;
            servicesCarouselInteriorConRef.current.style.bottom = `unset`;
        } else if (servCarBlock.bottom < window.innerHeight ){
            servicesCarouselInteriorConRef.current.style.position = 'absolute';
            servicesCarouselInteriorConRef.current.style.bottom = `0`;
            servicesCarouselInteriorConRef.current.style.top = `unset`;
        }            

    }

    const expandServiceBlock = (item,index) => {
        setServiceActiveSlide(index);
    }

    const closeServiceBlock = () => {
        setServiceActiveSlide(null);
    }

    useEffect(() => {
        // Initial check for section visibility
        onScrollFunction();
        
        window.addEventListener('mousemove', mouseMoveFunction);
        window.addEventListener('scroll', onScrollFunction);
        return () => {
            window.removeEventListener('scroll', onScrollFunction);
            window.removeEventListener('mousemove', mouseMoveFunction);
        }
    },[]);

    class SpinnerObj {
        constructor(topText1,topText2,bottomText1,bottomText2,imgNo){
            this.topText1 = topText1;
            this.topText2 = topText2;
            this.bottomText1 = bottomText1;
            this.bottomText2 = bottomText2;
            this.imgNo = imgNo;
        }
    };

    const spinnersArray = [
        new SpinnerObj('Think wide','& far','Innovate &','create change',"1"),
        new SpinnerObj('Always learn','& Improve','Aim for better','',"2"),
        new SpinnerObj('Listen','& respond','Show honesty','& respect',"3"),
        new SpinnerObj('Love','the detail','Create WOW','',"4")
    ];

    class ServicesItems {
        constructor(id,headingText,bodyText){
            this.id = id;
            this.headingText = headingText;
            this.bodyText = bodyText;
        }
    }

    const servicesArray = [
        new ServicesItems('service1','Brand Identity','We help to create brands that deliver the essence of your product or service. We offer support in logo design, brand positioning, tone of voice and everything else needed to help you resonate with your audience.'),
        new ServicesItems('service2','Brand Management & Implementation','Good brand management is at the core of our focus. We embody your brand through immersing ourselves in everything you do, working closely with your team to drive both consistency and distinction in every application.'),
        new ServicesItems('service3','Signage & Environmental Graphics','We understand the importance and balance of well executed signage. Our team is adept at understanding the priorities of brand presence over budget and work with sites and suppliers to ensure each scheme is executed in detail and to the specific needs of each site.'),
        new ServicesItems('service4','Project Management','Our focus is not only on the perfect scheme but the perfect delivery of each project phase from start to finish. We collaborate with our suppliers to make sure all elements of each project are thoroughly assessed and managed with continuous feedback to all key stakeholders.'),
        new ServicesItems('service5','Exhibition Design','When it comes to exhibitions its important that your experience is both true to your brand but also unique. Our aim is to create unique experiences that help your brand resonate with your audience and rise above the competition, whilst considering the importance of re-use and sustainability at all times. Our experienced designers work with you and your team throughout the design, build, delivery and installation phases to ensure your event is a success.'),
        new ServicesItems('service6','Animation Design','Animated video content allows you to get your message across in a short space of time with high levels of customer engagement. We offer services from highly visual motion graphics to creating fully immersive 3D animated scenes.'),
        new ServicesItems('service7','Interior & Architectural Design','We design, manage and fuse both structural and interior design in one streamlined process in house. This continuity, and by combining our efforts and knowledge, allows us to deliver more cohesive, and holistic spatial solutions at a higher calibre.'),
        new ServicesItems('service8','Industrial Product Design','We dedicate our time to our clients to understand their vision, thoroughly define the brief or underpin the problem at its source, to deliver considered and well executed products by blending creative vision and technical know-how with our own twist.')
    ];

    const hoverGridSection = (column,row) => {
        const colObject = {
            1: '5fr 1fr 1fr',
            2: '1fr 5fr 1fr',
            3: '1fr 1fr 5fr'
        };
        const rowObject = {
            1: '5fr 1fr 1fr',
            2: '1fr 5fr 1fr',
            3: '1fr 1fr 5fr'
        };
        expandingGridRef.current.style.gridTemplateColumns = colObject[column];
        expandingGridRef.current.style.gridTemplateRows = rowObject[row];
    }

    const hoverGridReset = () => {
        expandingGridRef.current.style.gridTemplateColumns = '1fr 1fr 1fr';
        expandingGridRef.current.style.gridTemplateRows = '1fr 1fr 1fr';
    }

    return (
        <main>
            <section ref={movingLogoCon} className={styles.oToSContainer} id="pageTop">
                <div ref={movingLogoBlock}>
                    {displayMovingLogo? 
                    <div style={{position: 'relative'}}>
                        <div style={{position: 'absolute'}}>
                            <SLogoNew scrollState={logoStatePt1} height={'100vh'} width={'100cqw'} viewportHeight={window.innerHeight} mask={true} logoScale={`${1-0.5*(logoStatePt2)}`} background={'1'} maskId="titleSLogo"/>
                        </div>
                        <div style={{maskImage: `linear-gradient(0deg, black ${((logoStatePt2))*100}%, transparent 0%)`,height: '100vh',width: '100cqw'}}>
                            <SLogoNew scrollState={logoStatePt1} height={'100vh'} width={'100cqw'} viewportHeight={window.innerHeight} mask={true} logoScale={`${1-0.5*(logoStatePt2)}`} background={'1'} fill={'#ffffff'}/>
                            
                        </div>
                    </div> : ''}
                </div>
            </section>
            <section id="buildManageSection" className={`${styles.aboutUsSection} ${styles.buildManageSection}`}>
                <div style={{top: buildManageSectionTextStyles.top, opacity: buildManageSectionTextStyles.opacity}} className={`${styles.sectionText} ${styles.sectionTextBlack}`}>
                    <h2>We <span>Build</span>, <br/><span>Manage</span> & <br/><span>Implement</span><br/>Brands</h2>
                    <h5>We deliver connected brand experiences across both physical and digital touchpoints.</h5><h6>At Stratela, we provide strategic and innovative guidance that enhances both aesthetic value and functional performance. Our skills extend across product development and interior design to branding and graphic design, ensuring integrated, high‑impact solutions that transform ideas into results with precision and purpose.</h6>
                </div>
                <div className={`${styles.basicMaskRight}`}>
                    <ImageSwitcher imgPathArray={buildImgArray} stateValue={buildManageSectionImgStyles} specificStyle={styles.sectionImgBuildManage} sectionInView={buildManageSectionInView}/>
                </div>
            </section>
            <section id="ourServicesSection" className={`${styles.aboutUsSection} ${styles.ourServicesSection} ${openService? '' : styles.ourServicesSectionBgImg}`}>
                <div className={`${styles.ourServicesOverlay} ${openService !== ''? styles.darkOverlay : ''}`} style={{opacity: ourServicesOverlayOpacity.opacity}}></div>
                    <div className={styles.ourServicesTextCon} style={{opacity: ourServicesSectionTextStyles.opacity}}>
                        <div style={{top: ourServicesSectionTextStyles.top}} className={styles.sectionText}>
                            <h2>Our<br /> Services</h2>
                        </div>
                        <div className={styles.servicesOptions}>
                            {servicesArray.map((data) => <HoverTextPara mobileVersion={mobileVersion} data={data} openServiceObj={openServiceObj}/>)}
                        </div>
                    </div>
            </section>
            <section id="designStrategySection" className={`${styles.designStrategySection}`}>
                <div className={styles.designStrategyTextCon}>
                    <div style={{top: designStrategySectionTextStyles.top, opacity: designStrategySectionTextStyles.opacity}} className={`${styles.sectionText} ${styles.sectionTextBlack}`}>
                        <h2>Design<br/>& Strategy</h2>
                        <h5>We challenge conventional thinking, apply rigorous problem‑solving, and design solutions that drive meaningful improvement.</h5>
                        {/* <h5>We challenge the status quo.</h5> */}
                        <h6 className={styles.thin}>Aligning design decisions to customer needs whilst also considering business aspirations, stakeholders and user needs, enables us to undertake more effective and efficient product development.</h6>
                        {/* <h6 className={styles.thin}>Aligning design decisions to customer needs whilst also considering business aspirations, stakeholders and user needs, enables us to undertake more effective and efficient product development.</h6> */}
                    </div>
                </div>
                <div className={`${styles.circleMask}`}>
                    <ImageSwitcher imgPathArray={mobileVersion ? designStrategyImgArrayMobile : designStrategyImgArray} stateValue={designStrategySectionImgStyles} specificStyle={styles.sectionImgVision} sectionInView={designStrategySectionInView}/>
                </div>
            </section>
            <section id="aboutUsSection" className={styles.aboutUsSection}>
                <div style={{top: aboutUsSectionTextStyles.top, opacity: aboutUsSectionTextStyles.opacity}} className={`${styles.sectionText} ${styles.sectionTextRight} ${styles.sectionTextBlack}`}>
                    <h2>About Us</h2>
                    <h5>Stratela is a passionate, detail orientated, multidisciplinary creative design agency.</h5>
                    <h6 className={styles.thin}>Guided by curiosity and discipline, we join forces with clients to ignite ideas, challenge perceptions, and deliver lasting impact. Our work encompasses strategy and positioning, graphical identity, products and packaging, installations and events, websites and digital experiences, advertising and communications, 3D and data visualizations.</h6>
                </div>
                <div className={`${styles.basicMaskLeft}`}>
                    <ImageSwitcher imgPathArray={aboutUsImgArray} stateValue={aboutUsSectionImgStyles} sectionInView={aboutUsSectionInView}/>
                </div>
            </section>
            <section id="valuesSection" className={`${styles.valuesSection}`}>
                <div className={styles.valuesSectionHeadingCon}>
                    <h2>Values & Principles</h2>
                </div>
                <div className={styles.spinners}>
                    {spinnersArray.map((data) => <Spinners data={data}/>)}
                </div>
                <div className={styles.valuesSectionParaCon}>
                    <h6 className={styles.thin}>Client openness and transparency are values that we take into every project we work on.
                    At the heart of this is our belief in building strong relationships with our clients through surpassing expectations and effective communication.</h6>                    
                </div>
            </section>
            <section id="visionSection" className={`${styles.designStrategySection}`}>
                <div className={styles.designStrategyTextCon}>
                    <div style={{top: visionSectionTextStyles.top, opacity: visionSectionTextStyles.opacity}} className={`${styles.sectionText} ${styles.sectionTextBlack}`}>
                        <h2>Vision<br/> & Purpose​</h2>
                        <h5>We design because we believe that progress and positive change can be achieved through better design.</h5>
                        <h6 className={styles.thin}>We seek innovation through a human centred approach to aesthetics and function. With every problem comes an array of solutions. We support our clients through identifying and enacting these solutions and share in their growth and progress.</h6>
                    </div>
                </div>
                <div className={`${styles.basicMaskRight}`}>
                    <ImageSwitcher imgPathArray={visionImgArray} stateValue={visionSectionImgStyles} specificStyle={styles.sectionImgVision} sectionInView={visionSectionInView}/>
                </div>
            </section>
            <section className={styles.videoSection}>
                <video id="s_intro" autoPlay muted loop playsInline style={{pointerEvents: "none"}}>
                    <source src={require('./../../vids/S-Intro.mp4')} type="video/mp4"/>
                </video>
                {/* <h1 id="titleText" style={{top: headingStyles.top, opacity: headingStyles.opacity}}>Design<br/>& Strategy<br/>Agency</h1> */}
            </section>
            <section ref={firstImageCon} id="fullScreenImage" className={styles.fullScreenImageContainer}>
                <div ref={firstImage} className={styles.fullScreenImage}>

                </div>
            </section>
            {/* <section ref={servicesCarouselRef} className={styles.servicesCarousel}>
                <div ref={servicesCarouselInteriorConRef} className={styles.servicesInteriorCon}>
                <div className={styles.servicesProgressBar}>
                    <div className={styles.servicesProgressBarElement} style={{height: `${serviceProgress*100}%`}}>
                    </div>
                </div>
                    <div ref={servicesCarouselInteriorRef} className={styles.servicesInterior}>
                        {serviceBlockData.map((item,index) => (
                            <div className={styles.servicesBlockContainer}>
                                <div ref={serviceBlocks.current[index]} key={index} onClick={() => expandServiceBlock(item,index)} className={`${styles.servicesBlock} ${serviceCurrentSlide === index? styles.currentSlide : styles.stdSlide} ${serviceActiveSlide === index? styles.activeSlide : ''}`} style={{backgroundImage: `url(${item.img})`}}>
                                    <div className={styles.overlay}>{item.name}</div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section> */}
            {/* <div className={styles.perspectiveContainer}>
                <SLogoLoading height={'10rem'} fill={'#fff'}/>
            </div>
            <div className={styles.perspectiveContainer}>
                <div ref={tiltingBlockOuterRef} className={styles.perspectiveBlockOuter}>
                    <div ref={tiltingBlockRef} className={styles.perspectiveBlockInner}>
                        <div ref={glowBlockRef} className={styles.glowBlockOuter}>
                            <div className={styles.outerGlow}></div>
                            <div className={styles.glowBlockInner}>
                                <div className={styles.innerGlow}></div>
                                <div className={styles.perspectiveBlockText}>
                                    <h2>Heading text</h2>
                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed porttitor, nulla ut iaculis tincidunt, arcu nisi porta mauris, at imperdiet orci mi ac eros. Curabitur eu laoreet magna. Aenean consectetur justo at elementum tempus. Phasellus metus purus, luctus quis pellentesque vel, pulvinar et elit. Donec arcu sapien, sodales eu varius ac, tristique vitae urna. Etiam facilisis scelerisque tortor, ac vulputate arcu convallis tempor. In hac habitasse platea dictumst. Praesent tincidunt hendrerit ultricies. Morbi eu eros dictum dolor euismod rhoncus.
                    
                                    Maecenas eu maximus risus. Praesent eget cursus dui. Nam venenatis massa sit amet eros auctor mollis. Maecenas tincidunt blandit sapien ac pellentesque. Sed volutpat condimentum luctus. Sed nec purus ac eros lobortis semper sed at tellus. Phasellus tincidunt gravida dapibus. Aenean convallis rutrum mi vitae cursus. Aenean ultrices augue sed ante aliquet dignissim.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={styles.perspectiveContainer}>
                <div ref={expandingGridRef} className={styles.expandingGrid}>
                    <div className={`${styles.gridElement} ${styles.gridBgA}`} style={{gridColumn: '1/3', gridRow: '1/2'}} onClick={() => hoverGridSection(1,1)} onMouseLeave={hoverGridReset}></div>
                    <div className={`${styles.gridElement} ${styles.gridBgB}`} style={{gridColumn: '3/4', gridRow: '1/3'}} onClick={() => hoverGridSection(3,1)} onMouseLeave={hoverGridReset}></div>
                    <div className={`${styles.gridElement} ${styles.gridBgC}`} style={{gridColumn: '1/2', gridRow: '2/4'}} onClick={() => hoverGridSection(1,2)} onMouseLeave={hoverGridReset}></div>
                    <div className={`${styles.gridElement} ${styles.gridBgD}`} style={{gridColumn: '2/3', gridRow: '2/3'}} onClick={() => hoverGridSection(2,2)} onMouseLeave={hoverGridReset}></div>
                    <div className={`${styles.gridElement} ${styles.gridBgE}`} style={{gridColumn: '2/4', gridRow: '3/4'}} onClick={() => hoverGridSection(2,3)} onMouseLeave={hoverGridReset}></div>
                </div>
            </div> */}
            {/* <div className={styles.stickyBackground}></div> */}
            {/* <section ref={stickCon1Ref} className={`${styles.stickySectionContainer} ${styles.bgA}`}>
                <div ref={stickBlock1Ref} className={`${styles.stickySectionBlock}`}>
                    <div className={styles.sectionTextCard} style={{scale: `${1-0.2*stickyBlockState1}`,opacity: `${1-1*stickyBlockState1}`}}>
                        <h2>We <span>Build</span>, <br/><span>Manage</span> & <br/><span>Implement</span><br/>Brands</h2>
                        <h6>For clients and creative partners through the delivery of both physical and digital connected brand experiences.</h6>
                    </div>
                    <div className={styles.newimageSwitcherContainer}>

                    </div>
                </div>
            </section> */}
            {/* <section ref={stickCon2Ref} className={`${styles.stickySectionContainer} ${styles.bgB}`}>
                <div ref={stickBlock2Ref} className={`${styles.stickySectionBlock}`}>
                    <div className={styles.sectionTextCard} style={{scale: `${1-0.2*stickyBlockState2}`,opacity: `${1-1*stickyBlockState2}`}}>
                        <h2>Design<br/>& Strategy</h2>
                        <h5>We challenge the status quo.</h5>
                        <h6 className={styles.thin}>Aligning design decisions to customer needs whilst also considering business aspirations, stakeholders and user needs, enables us to undertake more effective and efficient product development.</h6>                    </div>
                    </div>
            </section> */}
            {/* <section ref={stickCon3Ref} className={`${styles.stickySectionContainer} ${styles.bgC}`}>
                <div ref={stickBlock3Ref} className={`${styles.stickySectionBlock}`}>
                    <div className={styles.sectionTextCard} style={{scale: `${1-0.2*stickyBlockState3}`,opacity: `${1-1*stickyBlockState3}`}}>
                        <h2>About Us</h2>
                        <h5>We are a passionate and creative design agency.</h5>
                        <h6 className={styles.thin}>In today’s competitive market, having a strong brand identity is crucial for any business. At Stratela, we understand the importance of creating a unique and memorable brand that resonates with its target audience.</h6>
                    </div>
                    <div className={styles.newimageSwitcherContainer}>
                        
                    </div>
                </div>
            </section> */}
        </main>
    )
}